<template>
    <nav aria-label="Page navigation">
        <ul class="pagination justify-content-center">
            <li :class="['page-item',{'disabled':currentPage==1}]">
                <b-button class="page-link" @click="pagePrevious">
                    <b-icon-chevron-left></b-icon-chevron-left>
                </b-button>
            </li>
            <li class="page-item">
                <span class="page-link">
                    <span v-text="rows"></span> {{$t('components.pagination.records')}}，
                    {{$t('components.pagination.each')}}
                    <select v-model="perpage" @change="topage(1)">
                        <option value="10">10</option>
                        <option value="20">20</option>
                        <option value="30">30</option>
                        <option value="40">40</option>
                        <option value="50">50</option>
                    </select>
                    {{$t('components.pagination.records')}}，
                <span style="white-space:nowrap;">
                    <select v-model="currentPage" @change="topage(currentPage)">
                        <option v-for="n in pageArray" :key='n' v-text="n" :value="n"></option>
                    </select>
                    /
                    <span v-text="maxPage"></span> {{$t('components.pagination.pages')}}
                </span>
                </span>
            </li>
            <li :class="['page-item',{'disabled':currentPage==maxPage}]">
                <b-button class="page-link" @click="pageNext">
                    <b-icon-chevron-right></b-icon-chevron-right>
                </b-button>
            </li>
        </ul>
    </nav>
</template>
<script>
    export default {
        name: 'pagination',
        props: ['rows', 'rowperpage', 'paging'],
        data: function () {
            return {
                currentPage: 1,
                perpage: 10
            }
        },
        created: function () {
            this.perpage = this.rowperpage || this.perpage;
            this.$emit('input', { skip: this.skip, take: this.take });
        },
        computed: {
            maxPage: function () {
                if (this.rows != undefined && this.rows != 0) {
                    return Math.ceil(this.rows / this.perpage);
                } else {
                    return 1;
                }
            },
            pageArray: function () {
                var array = [];
                for (var i = 1; i <= this.maxPage; i++) {
                    array.push(i);
                }
                return array;
            },
            skip: function () {
                return (this.currentPage - 1) * this.perpage;
            },
            take: function () {
                return this.perpage;
            }
        },
        methods: {
            topage: function (i) {
                this.currentPage = i;
                this.$emit('input', { page: this.currentPage, skip: this.skip, take: this.take });
                this.$emit('paging');
            },
            pagePrevious: function () {
                if (this.currentPage > 1) {
                    this.topage(this.currentPage - 1);
                }
            },
            pageNext: function () {
                if (this.currentPage < this.maxPage) {
                    this.topage(this.currentPage + 1);
                }
            }
        }
    }
</script>

<style>
</style>